function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewSkitterbookLogo = function SvgNewSkitterbookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 47.637 28.715"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(5.752 4.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1",
    transform: "matrix(.26458 0 0 .26458 74.468 127.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2-1",
    fill: "#e81b25",
    d: "M-181.43-496.863c-1.734 7.615-4.492 14.728-7.413 21.952a1482 1482 0 0 0-2.4 5.984 671 671 0 0 1-3.176 7.793 137 137 0 0 0-2.793 7.45c-2.998 8.227-2.998 8.227-6.312 10.658-2.526 1.058-4.953 1.735-7.622 2.348q-2.881.82-5.76 1.655c-.971.27-1.943.538-2.944.815-4.46 1.315-8.735 3.009-13.03 4.779l-2.505 1.028c-23.614 9.853-46.755 21.317-65.26 39.304l-1.897 1.766c-.513-1.11-.294-.879-.633-.892.223-10.698.66-20.36 2.01-30.974.295-2.329.574-4.659.851-6.99l.562-4.5.246-2.083c1.368-10.472 7.236-15.022 15.26-21.25 28.038-19.733 62.688-29.102 95.378-37.88l2.386-.642c2.053-.434 2.053-.434 5.052-.32",
    style: {
      fill: "#a3d5ff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4-5",
    fill: "#f47a05",
    d: "M-147.577-499.06c-2.323 7.484-5.223 14.591-8.406 21.746a1297 1297 0 0 0-13.38 31.532 344 344 0 0 1-2.608 6.16c-1.202 2.747-1.202 2.747-1.96 5.441-.927 2.663-1.668 4.252-3.658 6.262-4.818 1.854-9.697 2.47-14.798 3.126l-8.523 1.307-4.118.59c-30.844 4.483-67.028 13.668-93.557 30.313l-2.389 1.346-2.223-1.112c19.878-23.852 53.986-37.892 82.257-48.909l2.57-1.012q3.71-1.454 7.434-2.878l2.24-.862c3.135-1.17 5.498-1.917 8.875-1.917l.552-2.164c2.196-8.36 4.913-16.459 7.855-24.583l1.343-3.793 1.301-3.61 1.17-3.257c1.118-2.61 1.118-2.61 3.341-4.833 2.44-.8 4.912-1.505 7.395-2.162l2.21-.589q2.312-.613 4.627-1.216c2.362-.615 4.72-1.243 7.077-1.873 11.555-3.052 11.555-3.052 15.373-3.052z",
    style: {
      fill: "#86b4db",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3-7",
    fill: "#03356a",
    d: "M-123.15-478.604c-2.747 9.582-4.91 17.874-8.157 27.294-6.37 18.485-12.543 37.017-18.41 55.668-7.429-.404-14.85-.82-22.25-1.58-14.33-1.471-28.523-2.037-42.924-2.01l-3.331-.001c-25.686.042-50.916 2.132-75.937 8.234-3.463.678-3.463.678-6.655-.386 30.7-18.524 65.338-27.016 100.354-33.319l3.02-.553c6.067-1.047 11.513-2.275 17.67-2.105.47-1.405 1.197-1.948 1.666-3.353l.888-2.66c.8-2.41 1.586-4.823 2.37-7.237 9.987-30.296 9.987-30.296 17.303-35.943 5.604-2.366 11.326-3.484 17.34-3.068 6.083.327 10.882.911 17.052 1.02z",
    style: {
      fill: "#6993b7",
      fillOpacity: 0.996078,
      stroke: "#fff",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    }
  }))));
};
export { SvgNewSkitterbookLogo as ReactComponent };
export default __webpack_public_path__ + "assets/New Skitterbook Logo.1343778e8966680c17c674f4563862bb.svg";